
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useTicketEdit } from '@/modules/scratch/ticket/model/edit';
import { ScratchTicketOptions, ScratchTicketType } from '@/modules/scratch/ticket/model/mixins';
import { ROUTE_NAME_SCRATCH } from '@/modules/scratch/router';

export default defineComponent({
    name: ROUTE_NAME_SCRATCH.TICKET.EDIT,
    components: { AppFormRow, AppInput, AppSelect, AppDateTimePicker, AppButton, AppCard },
    setup() {
        const { model, v$, timeUnits, fetch, update } = useTicketEdit();

        onMounted(() => {
            fetch();
        });

        return { model, v$, ScratchTicketOptions, ScratchTicketType, timeUnits, update };
    }
});
